var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetPrimaryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICN-refresh",
    transform: "translate(-2368 -731)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1470",
    "data-name": "Rectangle 1470",
    width: 20,
    height: 20,
    rx: 3,
    transform: "translate(2368 731)",
    fill: "#227c9d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "restart_alt_FILL0_wght400_GRAD0_opsz48",
    d: "M18.92,24.9a10.18,10.18,0,0,0,6.459-2.73A7.742,7.742,0,0,0,28,16.332a7.466,7.466,0,0,0-1.108-3.919,8.577,8.577,0,0,0-3.1-3l-1.342,1.162a6.708,6.708,0,0,1,2.715,2.446,6.16,6.16,0,0,1,.967,3.311,6.261,6.261,0,0,1-2.059,4.676,8.362,8.362,0,0,1-5.148,2.27Zm-1.872,0V23.278A8.421,8.421,0,0,1,11.9,20.995a6.263,6.263,0,0,1-2.028-4.662,6.355,6.355,0,0,1,2.356-4.986,8.487,8.487,0,0,1,5.757-2.041h.624l-1.872,1.622,1.342,1.162,4.15-3.595L18.078,4.9,16.736,6.062l1.872,1.622h-.624A10.409,10.409,0,0,0,10.9,10.211a7.877,7.877,0,0,0-.3,11.959A10.115,10.115,0,0,0,17.048,24.9Z",
    transform: "translate(2360 726.1)",
    fill: "#227c9d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPrimaryIcon);
export default __webpack_public_path__ + "static/media/Reset-primary-icon.4acaf960e6a355bd1f3f4a062f870da3.svg";
export { ForwardRef as ReactComponent };